import { coreUrls } from '@/api/urls/core';

import { formatStringByKey } from '@/utilities/formatStringByKey';
import { setApiOptions } from '@/utilities/services';

import { ListResponse, RequestResponseType } from '../../../../models';

import { api } from '@/api/client';
import {
    GetProductByUUIDQueryParamType,
    ProductAttribute,
    ProductsByFiltersQueryParamType,
    ProductType
} from '@/server/services/core/product/models';
import { AxiosPromise } from 'axios';

export const getProductsByFiltersService = (queryParam: ProductsByFiltersQueryParamType): AxiosPromise<ListResponse<ProductType>> => {
    const options = setApiOptions(coreUrls.getProductsByFilters, { queryParam }, true);
    return api({ ...options, method: 'GET' });
};

export const getProductByUuidService = (
    uuid: string,
    queryParam?: GetProductByUUIDQueryParamType
): AxiosPromise<RequestResponseType<ProductType>> => {
    const options = setApiOptions(formatStringByKey(coreUrls.getProductByUuid, { uuid }), { queryParam }, true);
    return api({ ...options, method: 'GET' });
};

export const getProductAttributeByUuidService = (uuid: string): AxiosPromise<RequestResponseType<ProductAttribute[]>> => {
    const options = setApiOptions(formatStringByKey(coreUrls.getProductAttributeByUuid, { uuid }));
    return api({ ...options, method: 'GET' });
};
